<template>
  <v-app-bar app flat class="degradebar stone-appbar">
    <v-app-bar-nav-icon class="stone-appbar__menu-btn" @click.stop="emitclick(drawer)" />
    <div class="stone-appbar__title">{{ ($route && $route.meta && $route.meta.appBarTitle) || ($route && $route.name) || "Dashboard" }}</div>

    <v-spacer></v-spacer>

    <div class="stone-appbar__search-wrap d-none d-md-block">
      <v-text-field
        prepend-inner-icon="mdi-magnify"
        placeholder="Busca rápida..."
        dense
        hide-details
        solo
        flat
        class="stone-appbar__search"
      />
    </div>

    <v-btn icon small class="stone-appbar__notify-btn">
      <v-icon size="18" color="#8c95a4">mdi-bell-outline</v-icon>
    </v-btn>

    <v-btn
      v-if="showTrocarEmpresa"
      small
      text
      color="#4d5a70"
      class="ml-2 px-1 text-none font-weight-bold"
      style="min-width: auto; letter-spacing: 0.02em"
      @click="$emit('trocar-empresa')"
    >
      <v-icon left small>mdi-swap-horizontal</v-icon>
      Trocar
    </v-btn>

    <div class="stone-appbar__user">
      <div class="stone-appbar__user-text d-none d-sm-flex">
        <div class="stone-appbar__user-name">{{ nome }}</div>
        <div class="stone-appbar__user-role">{{ empresa || "Administrador" }}</div>
      </div>
      <v-avatar color="#f4d8bf" size="28">
        <v-img :src="avatar" v-if="avatar != null"></v-img>
        <v-img v-else src="../../assets/default_user.png"></v-img>
      </v-avatar>
    </div>

    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          width="20"
          height="20"
          color="transparent"
          v-bind="attrs"
          v-on="on"
          fab
          text
          class="stone-appbar__menu-activator"
        >
          <v-icon color="#8c95a4">mdi-menu-down </v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="callPerfil" link>
          <v-list-item-title>
            <v-icon color="#F27C00">mdi-account </v-icon>
            Perfil
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="sair" link>
          <v-list-item-title link>
            <v-icon color="#F27C00">mdi-logout-variant </v-icon>
            Sair
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isInadimplente === 'ok'" @click="routeFaturaGo()" link>
          <v-list-item-title>
            <v-icon color="error">mdi-alert-circle-outline</v-icon>
            Regularizar plano
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-for="item in items_menu"
          :to="item.to"
          color="#F27C00"
          :key="item.icon"
        >
          <v-list-item-title>
            <v-icon color="#F27C00">{{ item.icon }} </v-icon>
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>

import { mapActions } from "vuex";
export default {
  props: {
    items_menu: {},
    isInadimplente: {
      type: String,
      default: "",
    },
    empresa: {
      type: String,
      default: "",
    },
    nome: {
      type: String,
      default: "",
    },
   
    drawer: {
      type: Boolean,
    },
    /** Mais de um credor: abre modal em vez de voltar à tela de seleção. */
    showTrocarEmpresa: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    avatar: "../../assets/user.svg",
    time: 0,
  }),
  created() {},
  mounted() {
    this.buscarDados();
  },
  methods: {
    ...mapActions("auth", ["ActionSignOut"]),
    async sair() {
      try {
        await this.ActionSignOut();
        this.$router.push({ name: "login" });
      } catch (error) {
        alert(
          error.data ? error.data.message : "Não foi possivel sair do sistema"
        );
      }
    },
    callPerfil() {
      this.$router.push({ name: "Perfil de usuário" });
    },

    emitclick(drawer) {
      this.$emit("emit-drawer",drawer);
    
    },
    routeFaturaGo() {
      this.$router.push({ name: "Faturas" });
    },
    buscarDados() {
      this.$http
        .get("meuperfil", {
          cpf_cnpj: this.cpf_cnpj,
        })
        .then((response) => {
          this.user = response.data;
          this.avatarView();
        });
    },
    avatarView() {
      if (this.user.picture != null) {
        this.$http
          .get("verPdfUser/" + this.user.picture, {
            responseType: "blob",
          })
          .then(
            (response) => {
              const blob = new Blob([response.data]);
              const objectUrl = URL.createObjectURL(blob, {
                type: response.headers.map["content-type"],
              });

              this.avatar = objectUrl;
            },
            (response) => {
              console.log(response);
            }
          );
      }
    },

    perfilAcesso() {},
  },
};
</script>

<style scoped>
.color_active_blue {
  color: #f27c00 !important;
  font-size: 0.875rem !important;
}
.span {
  font-family: "Inter", sans-serif;
}
.degradebar {
  color: #1f2937;
  background: #ffffff !important;
  border-bottom: 1px solid #eceff4;
}
.colorblue {
  color: #f27c00 !important;
  font-size: 1.275rem !important;
}

.stone-appbar {
  padding: 0 8px;
}

.stone-appbar__menu-btn {
  color: #8c95a4 !important;
}

.stone-appbar__title {
  font-size: 22px;
  font-weight: 600;
  color: #2a3242;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stone-appbar >>> .v-toolbar__content {
  min-width: 0;
}

@media (max-width: 959px) {
  .stone-appbar__title {
    font-size: 18px;
  }
  .stone-appbar__user-role {
    max-width: 160px;
  }
}

.stone-appbar__search-wrap {
  width: 100%;
  max-width: 310px;
  margin-right: 12px;
}

.stone-appbar__search {
  margin-top: 0;
}

.stone-appbar__search >>> .v-input__slot {
  border-radius: 16px !important;
  background: #f3f4f6 !important;
  min-height: 34px !important;
  box-shadow: none !important;
}

.stone-appbar__search >>> input {
  font-size: 12px;
}

.stone-appbar__notify-btn {
  margin-right: 6px;
}

.stone-appbar__user {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.stone-appbar__user-text {
  flex-direction: column;
  min-width: 0;
  text-align: right;
  line-height: 1.2;
}

.stone-appbar__user-name {
  font-size: 13px;
  color: #313949;
  font-weight: 600;
}

.stone-appbar__user-role {
  font-size: 11px;
  color: #8c95a4;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stone-appbar__menu-activator {
  min-width: 28px !important;
}
</style>